import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IFaculty {
  id?: number;
  page_id?: number;
  component_id?: number;
  title?: string;
  title_text_color?: string;
  left_navigation_icon?: string;
  left_navigation_icon_alt?: string;
  right_navigation_icon?: string;
  right_navigation_icon_alt?: string;
  description?: string;
  description_text_color?: string;
  description_background_color?: string;
  background_color?: string;
  background_image?: string;
  background_image_alt?: string;
  title_1_color?: string;
  status?: boolean;
  variant?: string;
}

export async function createFaculty(payload: Partial<IFaculty>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.FACULTY.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateFaculty(id: number, payload: Partial<IFaculty>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.FACULTY.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

